import React, {useEffect, useState} from "react";
import './style.css'
import {YMaps, Map, Placemark, ZoomControl} from '@pbe/react-yandex-maps';
import ModalImageGallery from "../../../components/ModalImageGallery";
import {Image} from "semantic-ui-react";
import {useSelector} from "react-redux";
import {getLanguage} from "../../../components/LanguageModal/reducer";
import translations from "../../../components/LanguageModal/translations";
import SadIcon from "../../../icons/sad-icon.png";



export default function DescriptionCongressGras(props) {
    const { mixpanel } = props
    const defaultState = {
        center: [26.326785, 43.973484],
        zoom: 19,
        controls: [],
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        if (mixpanel) {
            mixpanel.track('View. Description Congress')
        }
    }, []);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const [modalActive, setModalActive] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    const modalImageGallery = () => (
        <ModalImageGallery
            open={modalActive}
            handleOpen={() => setModalActive(true)}
            handleClose={() => setModalActive(false)}
            images={[
                {
                    original: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_1-scaled.jpeg",
                    thumbnail: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_1-scaled.jpeg",
                },
                {
                    original: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_3-scaled.jpeg",
                    thumbnail: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_3-scaled.jpeg",
                },
                {
                    original: "https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_2-scaled.jpeg",
                    thumbnail: " https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_2-scaled.jpeg",
                },
            ]}
            showAsGallery={false}
            index={imageIndex}
        />);

        const onImgClick = (index) => {
            setImageIndex(index);
            setModalActive(true);
        }

        const GalleryCongress = () => {
            if (navigator.onLine) {
                return (
                    <>
                        <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_1-scaled.jpeg'
                               className='picture-congress' onClick={() => (onImgClick(0))}/>
                        <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_3-scaled.jpeg'
                               className='picture-congress' onClick={() => (onImgClick(1))}/>
                        <Image src='https://cms.asiaexpo.space/wp-content/uploads/2024/07/opis_kongressa_2-scaled.jpeg'
                               className='picture-congress' onClick={() => (onImgClick(2))}/>
                    </>
                )
            } else {
                return (
                    <div className='view-images'>
                        <img src={SadIcon} alt={""}/>
                        <span className='text-bookmark'>{languageString === 'ru'
                            ? 'Для просмотра изображений, пожалуйста, подключитесь к интернету'
                            : 'To view the images, please connect to the Internet'}</span>
                    </div>
                )
            }
        }


    return (
        <>
            <div className="container">
                <div id='cong-title' className="title-text gras-text">{t('aboutCongressTitle')}</div>
                <div className="main-text">
                    I Международная Саудовско-российская сельскохозяйственная выставка (GRAS I) пройдет в г. Бурайда,
                    регионе Эль-Касим, с 20 по 22 мая2025 года. Конгресс является важнейшим событием в Королевстве и на
                    Ближнем Востоке, а также ключевой и крупнейшей площадкой для встречи производителей и дистрибьюторов
                    в сфере сельского хозяйства и сельскохозяйственной продукции, поскольку Российская Федерация
                    является крупнейшей страной в этом секторе, характеризующейся глобальным разнообразием, техническим
                    развитием и инновациями, обеспечивающими сохранение качества продукции и окружающей среды.
                </div>
                {/*<div className="main-text">*/}
                {/*    {t('aboutTheCongressTwo')}*/}
                {/*</div>*/}

                <div className={'cong-indent'}></div>

                <div className="title-text gras-text">{t('congressBlocks')}</div>
                <div className="main-text">
                    <b>{t('exh')}</b> состоит из 8 отраслевых направлений, где будут представлены: Крупнейшие инвесторы
                    в аграрном секторе и отрасли переработки сельхозпродукции в Королевстве Саудовская Аравия,
                    Российской Федерации и других странах-участницах, владельцы бизнеса и лиц, принимающих решения из
                    государственного и частного секторов, инженеры и сельскохозяйственные консультанты, производители и
                    дистрибьюторы продуктов питания, специалисты по энергетике и ирригации, владельцы Ферм
                </div>

                {/*<div className='pictures-congress'>*/}
                {/*    {GalleryCongress()}*/}
                {/*</div>*/}

                <div className="title-text gras-text">Направления выставки</div>
                <div className="main-text">
                    <ul style={{paddingLeft: '15px'}}>
                        <li>Продукты питания и напитки</li>
                        <li>Машины и оборудование</li>
                        <li>Биотехнологии и ветеринария</li>
                        <li>Профессиональные образовательные программы</li>
                        <li>Разработки и исследования IT решения</li>
                        <li>Программа продовольственной безопасности</li>
                        <li>Растениеводство, продукты сх. Переработки</li>
                    </ul>
                </div>

                <div className={'cong-indent'}></div>

                <div className="title-text gras-text">{t('dateEvent')}</div>
                <div id='event-date' className="main-text"><b>20-22 мая 2025 года</b></div>

                <div className="subtitle-text gras-text">{t('congressHours')}</div>
                <div id='event-time' className="main-text">20 мая с 19:00 до 22:30</div>
                <div id='event-time' className="main-text">21 мая с 09:30 до 18:30</div>
                <div id='event-time' className="main-text">22 мая с 09:30 до 18:30</div>

                <div className={'cong-indent'}></div>

                <div className="title-text gras-text">{t('locationEvent')}</div>
                <div id='university' className="main-text">
                    <b>Культурный центр короля Халеда — это социальный и культурный комплекс в городе Бурайда. Создан специально для проведения мероприятий и конференций.</b>
                </div>

                <div className="main-text">
                    Идея создания центра возникла во время визита короля Халеда бин Абдулазиза Аль Сауда в регион Эль-Касим, недалеко от Эр-Рияда. Он выбрал место в центре города, в одном из его самых красивых районов. Комплекс расположен на двух главных улицах: Кинг Абдулазиз Роуд (King Abdulaziz Road) и Кинг Фахд Роуд (King Fahd Road).
                </div>
                <div className="main-text">
                    Культурный центр короля Халида включает в себя множество объектов, таких как крытый театр, открытый театр (Римский театр), главный зал для приемов, столовую, зал для оборудования, склады, зал для собраний и сад для семей.
                </div>
                <div className={'ymap'}></div>
                {navigator.onLine ?
                    (<YMaps query={languageString === "en" ? {lang: 'en_RU'} : {lang: "ru_RU"}}>
                        <Map
                            defaultState={defaultState}
                            width={"100%"}
                        >
                            <ZoomControl options={{float: "right"}}/>
                            <Placemark geometry={[26.326785, 43.973484]}/>
                        </Map>
                    </YMaps>) : (
                        // <div>
                        //     {languageString === 'ru'
                        //         ? 'Для просмотра карты, пожалуйста, подключитесь к интернету'
                        //         : 'To view the map, please connect to the Internet'}
                        // </div>
                        <div className='view-map'>
                            <img src={SadIcon} alt={""}/>
                            <span className='text-bookmark'>{languageString === 'ru'
                                ? 'Для просмотра карты, пожалуйста, подключитесь к интернету'
                                : 'To view the map, please connect to the Internet'}</span>
                        </div>
                    )}
            </div>
            {modalImageGallery()}
        </>
    );
}